import { appConfig } from 'brand-config';

/**
 * Whether this brand allows "collect payment information later" at new-business bind (#33891). On
 * for the mutual brands, off for Branch. Read from the build-time brand config; the backend
 * independently re-checks the same brand flag, so this only controls whether the checkbox is even
 * offered. Mirrors isMicroBiltBypassAllowed.
 */
export const isCollectPaymentLaterAllowed = () => Boolean(appConfig?.featureFlags?.collectPaymentLater);

/**
 * Resolves whether the "collect payment information later" flag should be sent for a bind (#33891).
 *
 * The checkbox is underwriting-only. This gate guarantees a non-underwriter session can never send
 * `collectPaymentLater: true` — even if the checkbox value were somehow set — before it reaches the
 * bind payload. The backend independently re-checks `CanApproveUWReview`, so this is
 * defense-in-depth on the FE.
 */
export const resolveCollectPaymentLater = (canApproveUWReview, checked) => Boolean(canApproveUWReview && checked);
